module.exports = __webpack_public_path__ + "static/img/media-data.f3ece79f.svg";